import React from "react";
import { Button } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

export const NichtErhalten: React.FC = () => {
  return (
    <div className='faq-shipment-not-received-wrapper'>
      <p>
        Wenn Sendungen sich in der Zustellung befinden, werden sie in der Regel
        taggleich bei Ihnen zugestellt. Die Zusteller sind dabei bis in den
        Nachmittag hinein auf den Straßen unterwegs. War eine Zustellung an
        diesem Tag nicht möglich, wird der Zusteller am nächsten Tag einen
        erneuten Versuch unternehmen.
      </p>

      <p>
        Sollte diese Meldung mehr als 3 Tage lang als Ergebnis der Sendungssuche
        ausgegeben werden, bitten wir Sie, sich an uns zu wenden.
      </p>
      <Button
        size='small'
        style={{ textTransform: 'none' }}
        variant='contained'
        endIcon={<ChevronRight />}
        className='my-3'
        href='https://www.pin-ag.de/servicecenter/sendungsverfolgung-recherche/formular-sendungsverfolgung'
      >
        <strong>Zum KontaktFormular</strong>
      </Button>
    </div>
  );
};
